import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import * as React from 'react';

var SpotMobileUser = function SpotMobileUser(props) {
  var maskId = "spot-login-mask-".concat(props['data-id']);
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props, {
    viewBox: "0 0 72 72"
  }), React.createElement("g", {
    fill: "#F8F8F8",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, React.createElement("g", null, React.createElement("g", null, React.createElement("mask", {
    id: maskId,
    fill: "#fff"
  }, React.createElement("ellipse", {
    cx: "35.641",
    cy: "35.53",
    rx: "35.641",
    ry: "35.53"
  })), React.createElement("g", {
    fill: "#F8F8F8",
    fillRule: "nonzero",
    mask: "url(#".concat(maskId, ")")
  }, React.createElement("path", {
    d: "M0 0H71.282V71.059H0z"
  })))), React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(15.122 3)"
  }, React.createElement("path", {
    fill: "#505050",
    d: "M39.07 0H2.001A1.908 1.908 0 00.093 1.908v58.123c0 1.054.854 1.909 1.908 1.909h37.07a1.908 1.908 0 001.908-1.909V1.908A1.908 1.908 0 0039.07 0z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M35.152 5.73H5.919a2.044 2.044 0 00-2.044 2.044v46.392c0 1.129.915 2.044 2.044 2.044h29.233a2.045 2.045 0 002.045-2.044V7.774a2.045 2.045 0 00-2.045-2.045z"
  }), React.createElement("ellipse", {
    cx: "19.343",
    cy: "59.036",
    fill: "#FFF",
    rx: "1.809",
    ry: "1.795"
  }), React.createElement("ellipse", {
    cx: "19.343",
    cy: "59.036",
    fill: "#EBF0F3",
    rx: "1.387",
    ry: "1.377"
  }), React.createElement("path", {
    fill: "#D5D6DB",
    d: "M19.535 59.903h-.388a.67.67 0 01-.669-.669v-.396c0-.369.3-.669.669-.669h.388c.369 0 .669.3.669.669v.396a.67.67 0 01-.669.669zm-.388-1.51c-.246 0-.445.2-.445.445v.396c0 .246.2.445.445.445h.388c.246 0 .445-.2.445-.445v-.396c0-.246-.2-.445-.445-.445h-.388z"
  }), React.createElement("path", {
    fill: "#FFF",
    d: "M25.316 3.722h-9.56a.175.175 0 01-.175-.174v-.464c0-.096.078-.174.175-.174h9.56c.096 0 .174.078.174.174v.464a.175.175 0 01-.174.174z"
  }), React.createElement("circle", {
    cx: "20.729",
    cy: "29.692",
    r: "5.734",
    fill: "#EC0000"
  }), React.createElement("path", {
    fill: "#EC0000",
    d: "M8.703 47.454c0-6.641 5.384-12.025 12.026-12.025 6.641 0 12.025 5.384 12.025 12.025"
  }))));
};

export default SpotMobileUser;